import * as math from "mathjs";

const amount2bsv = (amount) => {
  if (amount == 0) {
    return amount;
  } else {
    return math.bignumber(1e-8).mul(parseInt(amount)).toNumber().toFixed(8);
  }
};

const amount2btc = (amount) => math.bignumber(1e-8).mul(parseInt(amount)).toNumber();

const amount2Coin = (amount, coinType) => {
  switch (coinType) {
    case "BSV":
      return amount2bsv(amount);
    case "BTC":
      return amount2btc(amount);
    default:
      return amount;
  }
};

const bsv2cny = (amount, legacyMoney) =>
  math.bignumber(1e-8).mul(amount).mul(legacyMoney).toNumber();

const cny2Coin = (cny, legacyMoney) =>
  math.bignumber(cny).div(math.bignumber(legacyMoney)).toNumber();

const bsv2Amount = (amount) => math.bignumber(10e7).mul(amount).toNumber();

const amount2cny = (amount) => math.bignumber(1e-8).mul(parseInt(amount)).toNumber().toFixed(2);

// //校正币种
// const changeBCHCion = (coin?) => {
//   if (coin == "BCH") {
//     return "BSV";
//   } else {
//     return coin;
//   }
// };

export default {
  amount2bsv,
  bsv2cny,
  bsv2Amount,
  cny2Coin,
  amount2btc,
  amount2Coin,
  // changeBCHCion,
  amount2cny,
};
